export const ar = {
  "app.title": "survivrr.io",
  "menu.online": "متصل",
  "menu.offline": "غير متصل",
  "menu.play": "العب",
  "menu.name": "الاسم",
  "menu.ballColor": "لون الكرة",
  "menu.nameColor": "لون الاسم",
  "menu.moreInfo": "مزيد من المعلومات",
  "menu.moreInfoTitle": "مزيد من المعلومات",
  "menu.moreInfoSubtitle": "صفحات قانونية وتفاصيل ملفات تعريف الارتباط ومعلومات الاتصال.",
  "menu.back": "رجوع",
  "menu.privacySettings": "إعدادات الخصوصية",
  "menu.cookiePolicy": "سياسة ملفات تعريف الارتباط",
  "menu.privacyPolicy": "سياسة الخصوصية",
  "menu.termsOfService": "شروط الخدمة",
  "menu.emailButton": "راسلني بالبريد",
  "menu.websiteButton": "زر موقعي",
  "menu.contactEmailLabel": "البريد الإلكتروني للتواصل:",
  "menu.emailLabel": "البريد الإلكتروني:",
  "menu.websiteLabel": "زر موقعي:",
  "menu.nameRequired": "أدخل اسمًا أولًا.",
  "moreInfo.privacySettings.intro1": "يمكنك إدارة اختيارات الخصوصية في هذا الموقع من خلال رسالة الموافقة التي يعرضها مزود الإعلانات عندما تكون متاحة.",
  "moreInfo.privacySettings.intro2": "يمكنك أيضًا التحكم في ملفات تعريف الارتباط والتخزين المحلي من إعدادات المتصفح في أي وقت.",
  "moreInfo.privacySettings.adsHeading": "إعدادات الإعلانات",
  "moreInfo.privacySettings.adsParagraph": "قد يتم تقديم بعض الإعلانات بواسطة Google أو شركاء آخرين. يمكن أيضًا إدارة خيارات الإعلانات المخصصة مباشرة من إعدادات إعلانات Google.",
  "moreInfo.privacySettings.adsBullet1": "افتح إعدادات إعلانات Google على myadcenter.google.com.",
  "moreInfo.privacySettings.adsBullet2": "امسح ملفات تعريف الارتباط أو بيانات الموقع إذا أردت إعادة ضبط اختيارات الموافقة.",
  "moreInfo.privacySettings.adsBullet3": "استخدم إعدادات الخصوصية في المتصفح لحظر ملفات تعريف الارتباط أو الحد منها.",
  "moreInfo.privacySettings.localHeading": "الإعدادات المحلية",
  "moreInfo.privacySettings.localParagraph": "تخزن هذه اللعبة تفضيلات محلية أساسية مثل اسم اللاعب والألوان وتفضيل الصوت واللغة حتى يتذكرها الموقع على جهازك.",
  "moreInfo.cookiePolicy.intro1": "يستخدم هذا الموقع ملفات تعريف الارتباط وتقنيات تخزين مشابهة لتشغيل اللعبة وتذكر إعداداتك ودعم الإعلانات.",
  "moreInfo.cookiePolicy.intro2": "قد تُستخدم ملفات تعريف الارتباط أيضًا للقياس ومنع الاحتيال وتخصيص الإعلانات حسب اختيارات الموافقة والخدمات المفعلة في الموقع.",
  "moreInfo.cookiePolicy.typesHeading": "أنواع ملفات تعريف الارتباط والتخزين التي قد نستخدمها",
  "moreInfo.cookiePolicy.typeBullet1": "تخزين أساسي يستخدم لإبقاء الموقع يعمل.",
  "moreInfo.cookiePolicy.typeBullet2": "تخزين التفضيلات لتذكر اسمك وألوانك ولغتك وإعداد الصوت.",
  "moreInfo.cookiePolicy.typeBullet3": "ملفات تعريف ارتباط للإعلانات أو القياس يستخدمها شركاء إعلانيون مثل Google عند تفعيل الإعلانات.",
  "moreInfo.cookiePolicy.manageHeading": "كيفية إدارة ملفات تعريف الارتباط",
  "moreInfo.cookiePolicy.manageParagraph": "يمكنك إدارة ملفات تعريف الارتباط من خلال رسالة الموافقة في الموقع عند توفرها أو من إعدادات المتصفح. قد يؤثر تعطيل بعض الملفات على ميزات الموقع أو عرض الإعلانات.",
  "moreInfo.privacyPolicy.intro1": "هذا الموقع لعبة متصفح يديرها Michał Kierzkowski. نحاول جمع أقل قدر ممكن من المعلومات الشخصية.",
  "moreInfo.privacyPolicy.intro2": "لا يلزم إنشاء حساب للعب. قد تحفظ اللعبة تفضيلات محلية أساسية على جهازك وتعالج بيانات اللعب اللازمة للمباريات عبر الإنترنت.",
  "moreInfo.privacyPolicy.infoHeading": "المعلومات التي قد نعالجها",
  "moreInfo.privacyPolicy.infoBullet1": "اسم اللاعب الذي تختاره وإعدادات المظهر.",
  "moreInfo.privacyPolicy.infoBullet2": "بيانات جلسة أساسية لازمة لتشغيل ميزات اللعب الجماعي.",
  "moreInfo.privacyPolicy.infoBullet3": "بيانات الجهاز أو المتصفح أو الإعلانات التي يجمعها شركاء التحليلات أو الإعلانات إذا كانت هذه الخدمات مفعلة.",
  "moreInfo.privacyPolicy.useHeading": "كيف نستخدم المعلومات",
  "moreInfo.privacyPolicy.useBullet1": "لتشغيل اللعبة والغرف عبر الإنترنت.",
  "moreInfo.privacyPolicy.useBullet2": "لتذكر إعداداتك على جهازك.",
  "moreInfo.privacyPolicy.useBullet3": "لتحسين الأداء والأمان والاستقرار.",
  "moreInfo.privacyPolicy.useBullet4": "لعرض الإعلانات عند تفعيل الإعلانات.",
  "moreInfo.privacyPolicy.contactHeading": "التواصل",
  "moreInfo.privacyPolicy.contactParagraph1": "إذا كانت لديك أسئلة تتعلق بالخصوصية، راسل: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "الموقع: michalkierzkowski.com",
  "moreInfo.terms.intro1": "باستخدام هذا الموقع، توافق على استخدام اللعبة بطريقة قانونية وعادلة.",
  "moreInfo.terms.intro2": "تُقدم اللعبة كما هي وقد تتغير أو تتوقف أو تزال في أي وقت.",
  "moreInfo.terms.rulesHeading": "القواعد",
  "moreInfo.terms.ruleBullet1": "لا تستغل الأخطاء أو الغش أو الأتمتة أو الثغرات.",
  "moreInfo.terms.ruleBullet2": "لا تحاول الإضرار بالخدمة أو اللاعبين الآخرين.",
  "moreInfo.terms.ruleBullet3": "لا تستخدم أسماء أو محتوى مسيئًا أو غير قانوني أو مضللًا.",
  "moreInfo.terms.limitationHeading": "تحديد المسؤولية",
  "moreInfo.terms.limitationParagraph": "لسنا مسؤولين عن الخسائر أو الانقطاعات أو الأضرار الناتجة عن استخدام الموقع إلى أقصى حد يسمح به القانون.",
  "moreInfo.terms.changesHeading": "التغييرات",
  "moreInfo.terms.changesParagraph": "قد يتم تحديث هذه الشروط مستقبلًا. استمرار استخدام الموقع بعد التحديثات يعني قبولك للشروط المحدثة.",
  "status.offline": "بدء مباراة غير متصلة...",
  "status.connecting": "جارٍ الاتصال بالخادم...",
  "queue.title": "بانتظار غرفة",
  "queue.menu": "العودة إلى القائمة الرئيسية",
  "game.pressToMove": "اضغط في أي مكان للتحرك",
  "game.touchToMove": "المس أي مكان للتحرك",
  "game.leaderboard": "لوحة الصدارة",
  "game.hp": "الصحة",
  "game.level": "المستوى",
  "game.xp": "XP",
  "game.respawning": "جارٍ إعادة الظهور...",
  "gameEnd.title": "نهاية اللعبة",
  "gameEnd.winTitle": "لقد فزت",
  "gameEnd.subtitle": "انتهت المباراة. أعد الظهور لبدء الجولة التالية أو عد إلى القائمة.",
  "pause.title": "قائمة اللعبة",
  "pause.resume": "متابعة",
  "pause.menu": "العودة إلى القائمة الرئيسية",
  "upgrade.title": "اختر ترقية",
  "upgrade.generic.title": "ترقية",
  "upgrade.generic.description": "حسّن بناءك.",
  "upgrade.newWeaponPrefix": "سلاح جديد:",
  "upgrade.stat.maxHp.title": "أقصى صحة",
  "upgrade.stat.maxHp.description": "يزيد أقصى صحة.",
  "upgrade.stat.speed.title": "سرعة الحركة",
  "upgrade.stat.speed.description": "يزيد سرعة الحركة.",
  "upgrade.stat.generic.title": "ترقية إحصائية",
  "upgrade.stat.generic.description": "حسّن إحصاءاتك.",
  "upgrade.weapon.projectileShot.title": "طلقة مقذوف",
  "upgrade.weapon.projectileShot.description": "يضيف طلقات مقذوفة إلى بنائك.",
  "upgrade.weapon.orbitingBalls.title": "كرات مدارية",
  "upgrade.weapon.orbitingBalls.description": "يضيف كرات مدارية إلى بنائك.",
  "upgrade.weapon.damageZone.title": "منطقة ضرر",
  "upgrade.weapon.damageZone.description": "يضيف منطقة ضرر حول شخصيتك.",
  "upgrade.weapon.generic.title": "سلاح",
  "upgrade.weapon.generic.description": "أضف هذا السلاح إلى بنائك.",
  "upgrade.weaponUpgrade.frequency.title": "التكرار",
  "upgrade.weaponUpgrade.frequency.description": "هاجم بشكل أكثر تكرارًا.",
  "upgrade.weaponUpgrade.range.title": "المدى",
  "upgrade.weaponUpgrade.range.description": "يزيد مدى السلاح.",
  "upgrade.weaponUpgrade.projectileCount.title": "عدد المقذوفات",
  "upgrade.weaponUpgrade.projectileCount.description": "ينشئ مقذوفات أكثر.",
  "upgrade.weaponUpgrade.projectileSpeed.title": "سرعة المقذوف",
  "upgrade.weaponUpgrade.projectileSpeed.description": "يجعل المقذوفات أسرع.",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "السرعة المدارية",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "يجعل الكرات المدارية تدور أسرع.",
  "upgrade.weaponUpgrade.damage.title": "الضرر",
  "upgrade.weaponUpgrade.damage.description": "يسبب ضررًا أكبر.",
  "upgrade.weaponUpgrade.generic.title": "ترقية سلاح",
  "upgrade.weaponUpgrade.generic.description": "حسّن هذا السلاح.",
  "defeat.title": "هزيمة",
  "defeat.subtitle": "أعد الظهور أو عد إلى القائمة",
  "defeat.respawn": "إعادة الظهور",
  "defeat.menu": "القائمة الرئيسية",
  "error.generic": "حدث خطأ ما.",
} as const;
